export default {
    url: '/detail/:id',
    template: `
        <manage-templates-detail template = vm.template />
    `,
    resolve: {
        template (NotificationResource, $stateParams) {
            return NotificationResource.get({ id: $stateParams.id, expand: 'i18nInCompanyLang,activeI18n,templateI18ns' }).$promise;
        }
    },
    controller (template) {
        this.template = template;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/templates/detail/index.js